<template>
  <div>
    <WizardBox title="Import">
      <template v-slot:tools>
        
      </template>
      <template v-slot:content>
        <FormGroup v-bind:form="dataForm">
          <FormWizard ref="importExportWizard" :submitting="submitting" v-bind:tabList="tabList" @finished="submitImportExport" @stepChange="wizardStepChanged">
            <template v-slot:content>
              <FormWizardStep index="1" v-bind:active="true">
                <FormRow label="Type"><FormSelect :options="methodOptions" v-model="importExport.type" field="method" /></FormRow>
                <FormRow label="Resource"><FormSelect :options="resourceOptions" v-model="importExport.resourceType" field="resourceType" /></FormRow>
                <FormRow label="Resource Fields">
                  <FormButton class="btn-default btn-sm" @click="displayAvailableFieldList"><i class="far fa-eye" /> View Available Fields</FormButton>
                </FormRow>
                <FormRow label="Import File"><FormUpload v-model="importExport.uploadFileList" singleFile /></FormRow>
                <FormRow>
                  <p class="text-muted">
                    Upload Details:
                    <ol>
                      <li>Files must be CSV type. CSV files can be exported from Excel / Numbers / Sheets</li>
                      <li>First row must contain the column names to be able to map to system fields</li>
                      <li>Synergy will attempt to auto-detect column names and map to required system fields</li>
                    </ol>
                  </p>
                </FormRow>
              </FormWizardStep>

              <FormWizardStep index="2">
                <Spinner v-if="importExport.loadingMapping" />
                <StaticDataTable class="static-table-list" v-if="importExport.resultMapping && importExport.resultMapping.mappingResults">
                  <template v-slot:header>
                    <tr>
                      <th>Name</th>
                      <th>Field</th>
                      <th>Found Field</th>
                    </tr>
                  </template>
                  <template v-slot:body>
                    <tr v-for="(mapping, index) in importExport.resultMapping.mappingResults" :key="index">
                      <td class="font-weight-bold">{{mapping.label}}{{mapping.required ? ' *' : ''}}</td>
                      <td>{{mapping.field}}</td>
                      <td>
                        <FormSelect :value="getUserMapping(mapping.field)" @input="updateUserMapping(mapping.field, $event)" :options="mappingFieldLookup" />
                        <!-- {{mapping.autoDetected ? mapping.autoDetectedField : 'Not Found'}} -->
                      </td>
                    </tr>
                  </template>
                </StaticDataTable>
              </FormWizardStep>

              <FormWizardStep index="3">
                <Spinner v-if="importExport.loadingPreview" />
                <Scroller maxHeight="600" height="600">
                  <StaticDataTable class="static-table-list table-grid-lines" v-if="importExport.previewData && importExport.previewData.mappingResults" stickyHeader smallRows>
                    <template v-slot:header>
                      <tr>
                        <th>Row</th>
                        <th v-for="(mapping, index) in importExport.previewData.mappingResults" :key="index">{{mapping.label}}</th>
                      </tr>
                    </template>
                    <template v-slot:body>
                      <tr v-for="(row, rowIndex) in importExport.previewData.rows" :key="rowIndex">
                        <td>{{rowIndex + 1}}</td>
                        <td v-for="(mapping, index) in importExport.previewData.mappingResults" :key="index">{{row[mapping.field]}}</td>
                      </tr>
                    </template>
                  </StaticDataTable>
                </Scroller>
              </FormWizardStep>

            </template>
          </FormWizard>
        </FormGroup>
      </template>
    </WizardBox>

    <Popover ref="availableFieldPopover" placement="bottom" sizeClass="popover-w50" headerTitle="Available Field List" :showHeader="true" :scrollable="true">
      <div class="p-2">
        <Spinner v-if="availableFields.loading" />
        <StaticDataTable v-if="!availableFields.loading" class="static-table-list" variant="table-sm" stickyHeader>
          <template v-slot:header>
            <tr>
              <th><Tooltip label="If starred, this field is required" helpStyle>Field</Tooltip></th>
              <th>Description</th>
              <th>Type</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="fieldInfo in availableFields.list" :key="fieldInfo.field">
              <td>{{fieldInfo.field}}{{fieldInfo.required ? ' *' : ''}}</td>
              <td>{{fieldInfo.label}}</td>
              <td>{{fieldInfo.details}}</td>
            </tr>
          </template>
        </StaticDataTable>
      </div>
    </Popover>
  </div>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import WizardBox from '@/components/wizardBox'
import StaticDataTable from '@/components/table/staticDataTable.vue'
import Popover from '@/components/popover' 

import { ImportExportResourceTypes } from '@/store/types'

export default {
  name: "AdminToolImport",
  mixins: [form],
  components: {
    WizardBox,
    StaticDataTable,
    Popover
  },
  data: () => {
    return {
      submitting: false,
      methodOptions: [
        { value: 'import', name: 'Import' },
      ],
      resourceOptions: [
        { value: ImportExportResourceTypes.contact, name: 'Contacts' },
        { value: ImportExportResourceTypes.stock, name: 'Stock' },
        { value: ImportExportResourceTypes.stockCategory, name: 'Stock Category' },
        { value: ImportExportResourceTypes.stockGlassPricing, name: 'Stock - Glass Pricing' },
        { value: ImportExportResourceTypes.stockServicePricing, name: 'Stock - Service Pricing' },
        { value: ImportExportResourceTypes.glassSizes, name: 'Stock - Glass Sizes' },
        { value: ImportExportResourceTypes.glassSupplierBulkPricing, name: 'Stock - Glass Bulk Pricing' },
      ],
      dataForm: {},
      tabList: [
        { title: 'Upload' },
        { title: 'Field Mapping' },
        { title: 'Preview' }
      ],
      importExport: {
        type: 'import',
        resourceType: ImportExportResourceTypes.contact,
        loadingMapping: false,
        loadingPreview: false,
        userMapping: [],    // Changes applied by user
        resultMapping: {},
        previewData: {},
        uploadFileList: [],
      },
      availableFields: {
        loading: false,
        list: []
      }
    };
  },
  mounted() {
  },
  computed: {
    mappingFieldLookup() {
      var lookupList = [
        { value: '', name: 'Not Found' }
      ]
      if(this.importExport.resultMapping.foundFields) {
        
        lookupList = _.concat(lookupList, this.importExport.resultMapping.foundFields.map(foundField => {
          return { value: foundField, name: foundField }
        }))
      }
      return lookupList
    },
    mappingList() {
      return []
      
      // Note: Outdated
      switch(this.importExport.resourceType) {
        case ImportExportResourceTypes.stock:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Name', field: 'name', description: 'Stock item name' },
            { name: 'Note', field: 'note', description: 'Notes' },
            { name: 'Active', field: 'active', description: 'Boolean if the stock is enabled/active' },
            { name: 'Type', field: 'type', description: 'Stock type. Valid values are: "glass", "glassService", "general"' },
            { name: 'UoM', field: 'uom', description: 'Unit of measurement' },
            { name: 'Thickness', field: 'thickness', description: 'Thickness for glass / general types. In mm' },
            { name: 'Treatment', field: 'treatment', description: 'Treatment. "annealed" or "laminated"' },
            { name: 'Min Offcut Width', field: 'minOffcutWidth', description: 'Minimum offcut width for glass' },
            { name: 'Min Offcut Width', field: 'minOffcutHeight', description: 'Minimum offcut height for glass' },
          ]
        case ImportExportResourceTypes.stockGlassPricing:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Type', field: 'type', description: 'Pricing type/group. Must match the name in the pricing group list in inventory configuration' },
            { name: 'Active', field: 'active', description: 'Boolean if the pricing is enabled/active' },
            { name: 'Price', field: 'price', description: 'Sales price of the glass per square metre. In dollars' },
          ]
        case ImportExportResourceTypes.stockServicePricing:
          return [
            { name: 'Code', field: 'code', description: 'Unique Stock code' },
            { name: 'Type', field: 'type', description: 'Service pricing type. Valid values are: "annealed", "laminated", "toughened"' },
            { name: 'Active', field: 'active', description: 'Boolean if the pricing is enabled/active' },
            { name: 'Price', field: 'price', description: 'Service price of the glass in dollars. Based on UoM of the stock item' },
            { name: 'Min Charge Price', field: 'minChargePrice', description: 'Minimum charge of the service in dollars' },
            { name: 'Minimum Range', field: 'minRange', description: 'Minimum service pricing range. Must match the min range thickness of the service pricing type' },
            { name: 'Maximum Range', field: 'maxRange', description: 'Maximum service pricing range. Must match the max range thickness of the service pricing type' },
          ]
      }
      return []
    }
  },
  methods: {
     submitImportExport() {
      
      this.submitting = true
      this.$data.dataForm = this.clearFormResponse()

      if(this.$data.importExport.type == 'import') {
        // Temporarily disabled while working on other stuff
        // Will return to finish it completely for Glass Partners
        this.displayCustomMessageBox('Import', 'Import tool is currently disabled. Please contact support for assistance.')
        /*

        var importData = _.clone(this.$data.importExport)

        this.$apiService.adminService.importDataFile(importData)
        .then(response => {
          this.successToast('Data Imported')
          //this.$router.push(`/inventory/stock`)   // temp: disabled
        })
        .catch(err => {
          // Process errors
          this.$data.dataForm = this.processFormResponse(err)
          this.$refs.importExportWizard.displayErrors()
        })
        .finally(() => {
          this.submitting = false
        })*/
      }
    },
    displayAvailableFieldList(evt) {
      this.availableFields.loading = true

      // Get the list of available fields for the selected resource
      this.$apiService.adminService.getImportMappingInfo({ resourceType: this.importExport.resourceType })
      .then(response => {
        this.availableFields.list = response.data

        // Setup 'details' for each field
        this.availableFields.list.forEach(fieldInfo => {
          fieldInfo.details = 'Text'

          if(fieldInfo.type == 'boolean') {
            fieldInfo.details = 'True/False'
          }
          else if(fieldInfo.type == 'enum') {
            fieldInfo.details = 'Valid values: ' + (fieldInfo.options || []).join(', ')
          }
          else if(fieldInfo.type == 'number') {
            fieldInfo.details = 'Number'
          }
        })
      })
      .catch(err => {
        this.displayNetworkError(err)
      })
      .finally(() => {
        this.availableFields.loading = false
      })

      this.$refs.availableFieldPopover.displayFromElement(evt.target)      
    },
    wizardStepChanged(tabIndex) {
      // Re-calculate the mapping list when the user goes to the mapping step
      if(tabIndex == 1) {
        this.recalculateMappingList()
      }
      if(tabIndex == 2) {
        this.calculatePreviewData()
      }
    },
    recalculateMappingList() {
      this.importExport.loadingMapping = true

      // Get the list of available fields for the selected resource
      var autoDetectData = {
        resourceType: this.importExport.resourceType,
        userMapping: [],
        uploadFileList: this.importExport.uploadFileList
      }

      autoDetectData.userMapping = _.compact(this.importExport.userMapping.map(mapping => {
        if(mapping.autoDetectedField == null || mapping.autoDetectedField == '')
          return null
        
        return {
          field: mapping.field,
          dataField: mapping.autoDetectedField
        }
      }))

      // TEMP - During testing
      autoDetectData.uploadFileList = [
        {
          key: 'account-1-77a1/60569304-43d2-4a1f-a1ed-84d62944b033-spil-contact-list---sheet1.csv'
        }
      ]

      this.$apiService.adminService.autoDetectImportMapping(autoDetectData)
      .then(response => {
        this.importExport.resultMapping = response.data

        // Copy to user mapping
        this.importExport.userMapping = _.cloneDeep(this.importExport.resultMapping.mappingResults)
      })
      .catch(err => {
        this.displayNetworkError(err)
      })
      .finally(() => {
        this.importExport.loadingMapping = false
      })
    },

    calculatePreviewData() {
      this.importExport.loadingPreview = true

      // Get the list of available fields for the selected resource
      var autoDetectData = {
        resourceType: this.importExport.resourceType,
        userMapping: [],
        uploadFileList: this.importExport.uploadFileList
      }

      autoDetectData.userMapping = _.compact(this.importExport.userMapping.map(mapping => {
        if(mapping.autoDetectedField == null || mapping.autoDetectedField == '')
          return null

        return {
          field: mapping.field,
          dataField: mapping.autoDetectedField
        }
      }))

      // TEMP - During testing
      autoDetectData.uploadFileList = [
        {
          key: 'account-1-77a1/60569304-43d2-4a1f-a1ed-84d62944b033-spil-contact-list---sheet1.csv'
        }
      ]

      this.$apiService.adminService.previewImportData(autoDetectData)
      .then(response => {
        this.importExport.previewData = response.data
      })
      .catch(err => {
        this.displayNetworkError(err)
      })
      .finally(() => {
        this.importExport.loadingPreview = false
      })
    },

    getUserMapping(field) {
      var mapping = this.importExport.userMapping.find(mapping => mapping.field == field)
      if(mapping) {
        return mapping.autoDetectedField
      }
      return ''
    },
    updateUserMapping(field, value) {
      var mapping = this.importExport.userMapping.find(mapping => mapping.field == field)
      if(mapping) {
        mapping.autoDetectedField = value
      }
    }
  }
}

</script>